import { sectorsInfoList } from 'helper/helper';
import UseContext from 'hooks/useContext';
import AdditionalInfoSection from './additionalInfoSection';
import DescriptionSection from './descriptionSection';
import InvitationNotificationSection from './invitationNotificationSection';
import LocationSection from './locationSection';
import PrerequisitesSection from './prerequisitesSection';
import ReasonSection from './reasonSection';
import RemunerationSection from './remunerationSection';
import ResponsibleInfoSection from './responsibleInfoSection';

const slideOverAddMissionConfirmation = ({ setPage }) => {
  const { dataCreateMission } = UseContext();
  const sectorsInfo = sectorsInfoList();

  return (
    <div className="flex flex-col gap-8">
      <p className="ft-xl text-gray-900 font-medium">
        Confirmer la création de mission
      </p>
      <DescriptionSection
        dataCreateMission={dataCreateMission}
        sectorsInfo={sectorsInfo}
        setPage={setPage}
      />
      <PrerequisitesSection
        dataCreateMission={dataCreateMission}
        setPage={setPage}
      />
      <ReasonSection dataCreateMission={dataCreateMission} setPage={setPage} />
      <LocationSection
        dataCreateMission={dataCreateMission}
        setPage={setPage}
      />
      <ResponsibleInfoSection
        dataCreateMission={dataCreateMission}
        setPage={setPage}
      />
      <RemunerationSection
        dataCreateMission={dataCreateMission}
        setPage={setPage}
      />
      <InvitationNotificationSection
        dataCreateMission={dataCreateMission}
        setPage={setPage}
      />
      <AdditionalInfoSection
        dataCreateMission={dataCreateMission}
        setPage={setPage}
      />
    </div>
  );
};

export default slideOverAddMissionConfirmation;
